import { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { Icons } from 'assets';
import { HStack, SVG, Skeleton } from 'components';
import { Button } from 'components/ui';

type RatingProps = {
  tenantId: string;
};

export const Rating: FC<RatingProps> = observer(({ tenantId }) => {
  const { tenants } = useStore();
  const currentTenantRating = tenants.getTenantRatingById(tenantId);

  useEffect(() => {
    if (tenantId && tenants.statuses.tenantRating.readyToLoad) {
      tenants.getTenantRating(tenantId);
    }
  }, [tenantId, tenants]);

  if (!tenantId) {
    return null;
  }

  return (
    <HStack spacing={'xs'} align="center">
      {tenants.statuses.tenantRating.pending && !currentTenantRating && (
        <Skeleton overlay />
      )}
      <Button
        leftIcon={<SVG src={Icons.ThumbsUp} props={{ isMirror: true }} />}
        size="xs"
        mode="error"
        variant="ghost"
        selected={currentTenantRating?.current_rate === 'down'}
        onClick={() => tenants.newRateTenant(tenantId, 'down')}
      >
        {currentTenantRating?.down}
      </Button>
      <Button
        leftIcon={<SVG src={Icons.ThumbsUp} />}
        size="xs"
        mode="success"
        variant="ghost"
        selected={currentTenantRating?.current_rate === 'up'}
        onClick={() => tenants.newRateTenant(tenantId, 'up')}
      >
        {currentTenantRating?.up}
      </Button>
    </HStack>
  );
});
